import React from 'react';
import Title from '../miscellaneous/Title';
import {MAXTIME} from "../miscellaneous/constants";
import SortedTable from "../miscellaneous/SortedTable";
import {isFiltered, numberWithSpaces} from "../miscellaneous/functions";

let nbBenchmarks = 0
function initData(name) {
    return {
        solver: name, total: 0, sat: 0, unsat: 0,  unique: 0, nbBestTotal: 0, unsupported : 0, par2: 0
    }
}

function createResults(selectedSolvers, data, benchmarks, filters) {
    let tmp = [];
    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []
    for (let s of selectedSolvers) {
        let current = initData(s.name + " " + s.version)
        const d = data[s.id]
        for (let result of d) {
            if (isFiltered(filters, result) === false)
                continue;
            current.unsupported += (result.status === "UNSUPPORTED" ? 1 : 0)
            if (result.bug === 0 && result.time < filters.timeLimit) {
                current.sat += (result.status === "SAT" ? 1 : 0)
                current.unsat += (result.status === "UNSAT" ? 1 : 0)
                current.total++;
                current.par2 += result.time
            } else
                current.par2 += (filters.timeLimit * 2);
        }
        tmp.push(current);
    }


    // Unique
    nbBenchmarks = 0
    for (let i = 0; i < benchmarks.length; i++) {
        if (isFiltered(filters, benchmarks[i]) === false)
            continue;
        let unique = -1
        let j = 0
        nbBenchmarks++
        for (let s of selectedSolvers) {
            if(data[s.id][i].bug === 1)
                continue
            if (((filters.selection === "ALL" && data[s.id][i].status !== "UNKNOWN") || data[s.id][i].status === filters.selection) && data[s.id][i].time < filters.timeLimit)
                unique = (unique === -1 ? j : -2)
            j++
        }
        if (unique >= 0) tmp[unique].unique++
    }


    let current = initData("<i>Virtual Best Solver</i>")

    for (let i = 0; i < benchmarks.length; i++) {
        if (isFiltered(filters, benchmarks[i]) === false)
            continue
        let sat = false
        let unsat = false
        let tl = MAXTIME
        let unsupported = true
        for (let j = 0; j < data.length; j++) {
            if (data[j] === undefined) continue;
            let r = data[j][i]
            if(r.status !== "UNSUPPORTED")
                unsupported = false
            if (r.status === "SAT" && r.time < filters.timeLimit && r.bug === 0) {
                sat = true
                if (tl > r.time)
                    tl = r.time
            }
            if (r.status === "UNSAT" && r.time < filters.timeLimit && r.bug === 0) {
                unsat = true
                if (tl > r.time)
                    tl = r.time
            }
        }

        if(unsupported) current.unsupported++
        if (sat) current.sat++
        if (unsat) current.unsat++
        current.par2 += sat || unsat ? tl : (filters.timeLimit * 2)
        if (sat || unsat) current.total++

        for (let j = 0; j < data.length; j++) {
            if (data[j] === undefined) continue;
            let position = selectedSolvers.findIndex(s => s.id === j);
            if (filters.name.length >= 3 && data[j][i].name.includes(filters.name) === false)
                continue;
            if (data[j][i].time === tl && tl !== MAXTIME && data[j][i].bug === 0) {
                if(sat && benchmarks[i].status === "SAT") tmp[position].nbBestTotal++
                if(unsat && benchmarks[i].status === "UNSAT") tmp[position].nbBestTotal++
            }
        }

    }
    current.nbBestTotal = current.total;

    current.unique = tmp.reduce((acc, val) => acc + val.unique, 0)
    current.classes = "vbs"


    if (filters.selection === "SAT")
        for (let s of tmp) {
            s.unsat = s.par2 = " "
            //s.unsat = s.nbBestUNSAT = s.total = s.nbBestTotal = s.par2 = current.nbBestUNSAT = " "
            current.unsat =  current.par2 = " "
        }


    if (filters.selection === "UNSAT")
        for (let s of tmp) {
            s.sat = s.par2 =  " "
            current.sat = current.par2 = " "
        }

    tmp.push(current)
    return tmp;
}

function nbWithStatus(benchmarks, status, nameFilter) {
    let tmp = 0;
    for (let b of benchmarks) {
        if (nameFilter.length >= 3 && b.name.includes(nameFilter) === false)
            continue;
        if (b.status === status)
            tmp++;
    }
    return tmp;
}


export default function Summary(props) {


    if (props.selectedSolvers.length === 0) return null;

    let rows = createResults(props.selectedSolvers, props.results, props.benchmarks, props.filters)

    if (rows.length === 0) return null;

    let nbSAT = nbWithStatus(props.benchmarks, "SAT", props.filters.name)
    let nbUNSAT = nbWithStatus(props.benchmarks, "UNSAT", props.filters.name)


    const headCells = [
        {id: 'solver', numeric: false, disablePadding: true, label: 'Solver'},
        {id: 'total', numeric: true, disablePadding: false, label: "#Solved"},
        {id: 'sat', numeric: true, disablePadding: false, label: "#SAT"},
        {id: 'unsat', numeric: true, disablePadding: false, label: "#UNSAT"},
        {id: 'unique', numeric: true, disablePadding: false, label: "#Exclusive"},
        {id: 'nbBestTotal', numeric: true, disablePadding: false, label: "#Fastest"},
        {id: 'unsupported', numeric: true, disablePadding: false, label: "#Unsupported"},
        {id: 'par2', numeric: true, disablePadding: false, label: "PAR 2"},

    ];
    for(let r of rows) {
        r["total"] = numberWithSpaces(r["total"])
        r["par2"] = numberWithSpaces(r["par2"])
        r["sat"] = numberWithSpaces(r["sat"])
        r["unsat"] = numberWithSpaces(r["unsat"])
        r["unique"] = numberWithSpaces(r["unique"])
        r["nbBestTotal"] = numberWithSpaces(r["nbBestTotal"])
        r["unsupported"] = numberWithSpaces(r["unsupported"])

    }
    return (
        <React.Fragment>
            <Title ><span style={{color:'#408033'}}>Ranking of Solvers</span></Title>
            <strong style={{color:'#408033'}}>Nb selected instances: {nbBenchmarks} </strong>
            <SortedTable rows={rows} headCells={headCells} order={'total'} asc={'desc'}/>
        </React.Fragment>
    )
}